import apiService from '@/services/apiService';

const actions = {
  getGeneralSettings({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('messaging/setting/general/whatsapp')
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postGeneralSettings({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('messaging/setting/general/whatsapp', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};

export default actions;